import { QuestionYesNoField } from 'components/Questionnaires/fields';
import { requiredValidator } from 'components/Questionnaires/validators';
import { getKey, DocumentKeys } from 'common/forms/documentTypes';
import { uploadSupportingDocField } from 'common/questionnaires/definitions/fields';

export const NonwithholdingTypes = {
  FOREIGN_PARTNERSHIP: { id: 'nonwithholdingForeignPartnership', languageId: 'foreignPartnership' },
  FOREIGN_SIMPLE_TRUST: { id: 'nonwithholdingForeignSimpleTrust', languageId: 'foreignSimpleTrust' },
  FOREIGN_GRANTOR_TRUST: { id: 'nonwithholdingForeignGrantorTrust', languageId: 'foreignGrantorTrust' }
};

export function nonwithholdingBlock({ nonwithholdingType, visible }) {
  const showIsLowerTierPartnership = () => nonwithholdingType === NonwithholdingTypes.FOREIGN_PARTNERSHIP || nonwithholdingType === NonwithholdingTypes.FOREIGN_GRANTOR_TRUST;
  const showIsProvidingEachGrantor = () => nonwithholdingType === NonwithholdingTypes.FOREIGN_GRANTOR_TRUST;
  const showIsSection1446f = () => nonwithholdingType === NonwithholdingTypes.FOREIGN_PARTNERSHIP;
  const showIsModifiedAmount = bAnswers => bAnswers?.isSection1446f === 'Yes';
  const showSimpleWithholdingStatement = bAnswers => bAnswers?.isAltStatement === 'No';
  const showAltWithholdingStatement = bAnswers => bAnswers?.isAltStatement === 'Yes';

  return {
    id: nonwithholdingType.id,
    title: `questionnaire.ch3.nonwithholding.${ nonwithholdingType.languageId }`,
    component: undefined,
    info: {
      instructions: `questionnaire.ch3.nonwithholding.${ nonwithholdingType.languageId }.info`,
    },
    visible,
    questions: [
      {
        id: 'isLowerTierPartnership',
        component: QuestionYesNoField,
        visible: showIsLowerTierPartnership,
        label: 'questionnaire.ch3.nonwithholding.isLowerTierPartnership.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.nonwithholding.isLowerTierPartnership.errorMessage' }
          ]
        }
      },
      {
        id: 'isProvidingEachGrantor',
        component: QuestionYesNoField,
        visible: showIsProvidingEachGrantor,
        label: 'questionnaire.ch3.nonwithholding.isProvidingEachGrantor.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.nonwithholding.isProvidingEachGrantor.errorMessage' }
          ]
        }
      },
      {
        id: 'isSection1446f',
        component: QuestionYesNoField,
        visible: showIsSection1446f,
        label: 'questionnaire.ch3.nonwithholding.isSection1446f.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.nonwithholding.isSection1446f.errorMessage' }
          ]
        }
      },
      {
        id: 'isModifiedAmount',
        component: QuestionYesNoField,
        visible: showIsModifiedAmount,
        label: 'questionnaire.ch3.nonwithholding.isModifiedAmount.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.nonwithholding.isModifiedAmount.errorMessage' }
          ]
        }
      },
      {
        id: 'isAltStatement',
        component: QuestionYesNoField,
        visible: true,
        label: 'questionnaire.ch3.nonwithholding.isAltStatement.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.nonwithholding.isAltStatement.errorMessage' }
          ]
        }
      },
      uploadSupportingDocField({
        id: 'simpleWithholdingStatement',
        docType: getKey(DocumentKeys.SIMPLE_WHD_STATEMENT),
        visible: showSimpleWithholdingStatement,
        hasFootnote: true
      }),
      uploadSupportingDocField({
        id: 'altWithholdingStatement',
        docType: getKey(DocumentKeys.ALT_WHD_STATEMENT),
        visible: showAltWithholdingStatement,
        hasFootnote: true
      })
    ]
  };
}

export default nonwithholdingBlock;
